import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetFiletype_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, filetype?: string | null };

export type AssetFiletype_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string, filetype?: string | null };

export type AssetFiletype_FileAsset_Fragment = { __typename?: 'FileAsset', id: string, filetype?: string | null };

export type AssetFiletype_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string, filetype?: string | null };

export type AssetFiletype_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string, filetype?: string | null };

export type AssetFiletype_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string, filetype?: string | null };

export type AssetFiletype_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string, filetype?: string | null };

export type AssetFiletype_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, filetype?: string | null };

export type AssetFiletype_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string, filetype?: string | null };

export type AssetFiletype_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string, filetype?: string | null };

export type AssetFiletype_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, filetype?: string | null };

export type AssetFiletypeFragment = AssetFiletype_AudioAsset_Fragment | AssetFiletype_DocumentAsset_Fragment | AssetFiletype_FileAsset_Fragment | AssetFiletype_FolderAsset_Fragment | AssetFiletype_ImageAsset_Fragment | AssetFiletype_InteractiveAsset_Fragment | AssetFiletype_InteractiveLiveAsset_Fragment | AssetFiletype_ModelAsset_Fragment | AssetFiletype_UnsupportedAsset_Fragment | AssetFiletype_VersionStackAsset_Fragment | AssetFiletype_VideoAsset_Fragment;

export const AssetFiletype = /*#__PURE__*/ gql`
    fragment AssetFiletype on Asset {
  id
  filetype
}
    ` as unknown as DocumentNode<AssetFiletypeFragment, unknown>;

        

        
export const useAssetFiletypeFragment = (
  input: string | Omit<UseFragmentOptions<AssetFiletypeFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetFiletypeFragment>({
    fragment: AssetFiletype,
    fragmentName: 'AssetFiletype',
    ...options,
  });
};
  
        